// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    GuarantorPayment,
    GuarantorPaymentFromJSON,
    GuarantorPaymentToJSON,
    ProviderCreateClaimFacility,
    ProviderCreateClaimFacilityFromJSON,
    ProviderCreateClaimFacilityToJSON,
    ProviderCreateClaimGuarantor,
    ProviderCreateClaimGuarantorFromJSON,
    ProviderCreateClaimGuarantorToJSON,
    ProviderCreateClaimPatient,
    ProviderCreateClaimPatientFromJSON,
    ProviderCreateClaimPatientToJSON,
    ProviderCreateClaimProvider,
    ProviderCreateClaimProviderFromJSON,
    ProviderCreateClaimProviderToJSON,
    ProviderCreateClaimSeller,
    ProviderCreateClaimSellerFromJSON,
    ProviderCreateClaimSellerToJSON,
    ProviderCreateClaimSubscriber,
    ProviderCreateClaimSubscriberFromJSON,
    ProviderCreateClaimSubscriberToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCreateClaimTypePayload
 */
export interface ProviderCreateClaimTypePayload {
    /**
     * If provided, it will attempt to update the existing claim if no claim types exist.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    claimId?: string;
    /**
     * The claim submitter identifier generated from the practice EMR/PMS to uniquely identify the claim.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    controlNumber?: string;
    /**
     * If more than 1 configured in the account, needs to be the guid of the billing provider id for the claim
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    billingProviderId?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof ProviderCreateClaimTypePayload
     */
    maximumGuarantorResponsibility?: Amount;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<GuarantorPayment>}
     * @memberof ProviderCreateClaimTypePayload
     */
    guarantorPayments?: Array<GuarantorPayment>;
    /**
     * Claim narrative
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    claimNarrative?: string;
    /**
     * The claim-level primary payer authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    primaryPayerAuthorizationNumber?: string;
    /**
     * The claim-level secondary payer authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    secondaryPayerAuthorizationNumber?: string;
    /**
     * The claim-level tertiary payer authorization number
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    tertiaryPayerAuthorizationNumber?: string;
    /**
     * The primary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    primaryThirdPartyAdministratorPayerId?: string;
    /**
     * The secondary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    secondaryThirdPartyAdministratorPayerId?: string;
    /**
     * The tertiary TPA payer id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof ProviderCreateClaimTypePayload
     */
    tertiaryThirdPartyAdministratorPayerId?: string;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimSubscriber>}
     * @memberof ProviderCreateClaimTypePayload
     */
    subscribers?: Array<ProviderCreateClaimSubscriber>;
    /**
     * 
     * OpenAPI data type: {ProviderCreateClaimPatient}
     * @type {ProviderCreateClaimPatient}
     * @memberof ProviderCreateClaimTypePayload
     */
    patient: ProviderCreateClaimPatient;
    /**
     * 
     * OpenAPI data type: {ProviderCreateClaimGuarantor}
     * @type {ProviderCreateClaimGuarantor}
     * @memberof ProviderCreateClaimTypePayload
     */
    guarantor: ProviderCreateClaimGuarantor;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<ProviderCreateClaimProvider>}
     * @memberof ProviderCreateClaimTypePayload
     */
    providers?: Array<ProviderCreateClaimProvider>;
    /**
     * 
     * OpenAPI data type: {ProviderCreateClaimSeller}
     * @type {ProviderCreateClaimSeller}
     * @memberof ProviderCreateClaimTypePayload
     */
    seller?: ProviderCreateClaimSeller;
    /**
     * 
     * OpenAPI data type: {ProviderCreateClaimFacility}
     * @type {ProviderCreateClaimFacility}
     * @memberof ProviderCreateClaimTypePayload
     */
    facility?: ProviderCreateClaimFacility;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof ProviderCreateClaimTypePayload
     */
    documents?: Array<string>;
}

export function ProviderCreateClaimTypePayloadFromJSON(json: any): ProviderCreateClaimTypePayload {
    return {
            'claimId': !exists(json, 'claimId') ? undefined : json['claimId'],
            'controlNumber': !exists(json, 'controlNumber') ? undefined : json['controlNumber'],
            'billingProviderId': !exists(json, 'billingProviderId') ? undefined : json['billingProviderId'],
            'maximumGuarantorResponsibility': !exists(json, 'maximumGuarantorResponsibility') ? undefined : AmountFromJSON(json['maximumGuarantorResponsibility']),
            'guarantorPayments': !exists(json, 'guarantorPayments') ? undefined : (json['guarantorPayments'] as Array<any>).map(GuarantorPaymentFromJSON),
            'claimNarrative': !exists(json, 'claimNarrative') ? undefined : json['claimNarrative'],
            'primaryPayerAuthorizationNumber': !exists(json, 'primaryPayerAuthorizationNumber') ? undefined : json['primaryPayerAuthorizationNumber'],
            'secondaryPayerAuthorizationNumber': !exists(json, 'secondaryPayerAuthorizationNumber') ? undefined : json['secondaryPayerAuthorizationNumber'],
            'tertiaryPayerAuthorizationNumber': !exists(json, 'tertiaryPayerAuthorizationNumber') ? undefined : json['tertiaryPayerAuthorizationNumber'],
            'primaryThirdPartyAdministratorPayerId': !exists(json, 'primaryThirdPartyAdministratorPayerId') ? undefined : json['primaryThirdPartyAdministratorPayerId'],
            'secondaryThirdPartyAdministratorPayerId': !exists(json, 'secondaryThirdPartyAdministratorPayerId') ? undefined : json['secondaryThirdPartyAdministratorPayerId'],
            'tertiaryThirdPartyAdministratorPayerId': !exists(json, 'tertiaryThirdPartyAdministratorPayerId') ? undefined : json['tertiaryThirdPartyAdministratorPayerId'],
            'subscribers': !exists(json, 'subscribers') ? undefined : (json['subscribers'] as Array<any>).map(ProviderCreateClaimSubscriberFromJSON),
            'patient': ProviderCreateClaimPatientFromJSON(json['patient']),
            'guarantor': ProviderCreateClaimGuarantorFromJSON(json['guarantor']),
            'providers': !exists(json, 'providers') ? undefined : (json['providers'] as Array<any>).map(ProviderCreateClaimProviderFromJSON),
            'seller': !exists(json, 'seller') ? undefined : ProviderCreateClaimSellerFromJSON(json['seller']),
            'facility': !exists(json, 'facility') ? undefined : ProviderCreateClaimFacilityFromJSON(json['facility']),
            'documents': !exists(json, 'documents') ? undefined : json['documents'],
    };

}

export function ProviderCreateClaimTypePayloadToForm(value?: ProviderCreateClaimTypePayload): any {
    let jsonVal = ProviderCreateClaimTypePayloadToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function ProviderCreateClaimTypePayloadToJSON(value?: ProviderCreateClaimTypePayload): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'claimId': cleanupBlankValuesForBackend(value.claimId),
            'controlNumber': cleanupBlankValuesForBackend(value.controlNumber),
            'billingProviderId': cleanupBlankValuesForBackend(value.billingProviderId),
            'maximumGuarantorResponsibility': AmountToJSON(value.maximumGuarantorResponsibility),
            'guarantorPayments': (value.guarantorPayments === undefined || value.guarantorPayments === null) ? undefined : (value.guarantorPayments as Array<any>).map(GuarantorPaymentToJSON),
            'claimNarrative': cleanupBlankValuesForBackend(value.claimNarrative),
            'primaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.primaryPayerAuthorizationNumber),
            'secondaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.secondaryPayerAuthorizationNumber),
            'tertiaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.tertiaryPayerAuthorizationNumber),
            'primaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.primaryThirdPartyAdministratorPayerId),
            'secondaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.secondaryThirdPartyAdministratorPayerId),
            'tertiaryThirdPartyAdministratorPayerId': cleanupBlankValuesForBackend(value.tertiaryThirdPartyAdministratorPayerId),
            'subscribers': (value.subscribers === undefined || value.subscribers === null) ? undefined : (value.subscribers as Array<any>).map(ProviderCreateClaimSubscriberToJSON),
            'patient': ProviderCreateClaimPatientToJSON(value.patient),
            'guarantor': ProviderCreateClaimGuarantorToJSON(value.guarantor),
            'providers': (value.providers === undefined || value.providers === null) ? undefined : (value.providers as Array<any>).map(ProviderCreateClaimProviderToJSON),
            'seller': ProviderCreateClaimSellerToJSON(value.seller),
            'facility': ProviderCreateClaimFacilityToJSON(value.facility),
            'documents': cleanupBlankValuesForBackend(value.documents),
    };
}


